export const alertTheme = {
  defaultPadding: "16px 18px",
};
